import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_shell/contract-templates/$templateId')({
  beforeLoad: () => {
    throw redirect({ to: '/contract-templates' })
  },
})
